import { useDispatch, useSelector, useStore } from "react-redux"

import type { AppDispatch, AppStore, LoggedInState, LoggedOutState, RootState } from "./store"

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()

// Narrowed selectors for use inside withProtectedRoute / withAnonymousRoute.
// The route HOC guarantees auth shape before mounting children, so callers can
// treat state.auth as non-null (or null) without per-call optional chaining.
export const useLoggedInAppSelector = useSelector.withTypes<LoggedInState>()
export const useLoggedOutAppSelector = useSelector.withTypes<LoggedOutState>()
